.d1{aspect-ratio:1/1;}